interface ChapterDividerProps {
  chapterNumber?: number;
  chapterTitle?: string;
  isLast?: boolean;
}

export function ChapterDivider({ chapterNumber, chapterTitle, isLast }: ChapterDividerProps) {
  if (isLast) {
    return (
      <div className="flex flex-col items-center justify-center py-16 mt-8">
        <div className="w-16 h-px bg-gradient-to-r from-transparent via-[var(--border)] to-transparent mb-6" />
        <p className="font-ui text-[10px] text-[var(--text-tertiary)] uppercase tracking-[0.3em]">
          End of Story
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-12 my-8">
      <div className="w-2 h-2 rounded-full bg-[var(--accent)]/30 mb-4" />
      <p className="font-ui text-[10px] text-[var(--text-tertiary)] uppercase tracking-[0.2em] mb-1">
        Chapter {chapterNumber}
      </p>
      <p className="font-body text-sm text-[var(--text-secondary)] italic">
        {chapterTitle}
      </p>
    </div>
  );
}
